import * as yup from "yup";
import moment from "moment";
import autoGenerateUsername from "config.json";
const model = {
  id: 0,
  memId: 0,
  ipAddress: "",
  macIPAddress: "",
  domainName: "",
  status: true,
};

const validationModel = yup.object().shape({
  whiteLabelLogoCss: yup.string().optional("").nullable(),
  merchantLogoCss: yup.string().optional("").nullable(),
  isMerchantInvoiceLogo: yup.string().optional("").nullable(),
  isCorporate: yup.string().optional("").nullable(),
  supplierPromocode: yup.string().optional().nullable(),
  isCharterFlight: yup.string().optional().nullable(),
});

export { model, validationModel };
